/* ============================================================
   UGM cart page. Quantity / remove / upsell-add use the AJAX Cart API with
   the `sections` parameter so the server re-renders the whole cart section
   (totals, free-ship meter, bundle savings, upsell) in one round-trip.
   Listeners are delegated on document so they survive section re-renders.
   ============================================================ */
(function () {
  'use strict';
  const routes = window.routes || {};

  function getRoot() { return document.getElementById('ugm-cart'); }
  function sectionId() { const r = getRoot(); return r ? r.dataset.sectionId : null; }

  async function mutate(url, body) {
    const sid = sectionId();
    if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
    const res = await fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    rerender(data, sid);
    return data;
  }

  function rerender(data, sid) {
    const html = data.sections && sid && data.sections[sid];
    const root = getRoot();
    if (html && root) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('ugm-cart');
      if (fresh) root.replaceWith(fresh);
    }
    // keep the header badge + drawer in sync
    if (window.UGM && window.UGM.cart) {
      if (typeof data.item_count === 'number') window.UGM.cart.setCount(data.item_count);
      else window.UGM.cart.refresh();
    }
  }

  // qty change / remove
  document.addEventListener('click', (e) => {
    const ch = e.target.closest('[data-cart-change]');
    if (ch) { e.preventDefault(); mutate(routes.cart_change_url, { line: Number(ch.dataset.cartChange), quantity: Number(ch.dataset.qty) }); return; }
    const add = e.target.closest('[data-cart-add]');
    if (add) { e.preventDefault(); add.disabled = true; mutate(routes.cart_add_url, { items: [{ id: Number(add.dataset.cartAdd), quantity: 1 }] }); return; }
  });

  // order note (debounced save)
  let noteTimer;
  document.addEventListener('input', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      fetch(routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value }),
      });
    }, 600);
  });

  // discount code — applied via the /discount/{code} link, returns to cart
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-cart-discount]');
    if (!form) return;
    e.preventDefault();
    const code = (form.querySelector('input') || {}).value;
    if (code && code.trim()) {
      window.location.href = '/discount/' + encodeURIComponent(code.trim()) + '?redirect=' + encodeURIComponent(window.location.pathname);
    }
  });
})();
